import Goals from './Goals';

export default Goals;
